import 'react-multi-carousel/lib/styles.css';

import * as actions from '../redux/actions';

import {
	HomeBanners,
	ThemeThreeContactForm,
	ThemeThreeIconsSection,
	ThemeThreeSearchBox,
	ThemeThreeTitle,
} from '..';

import Carousel from 'react-multi-carousel';
import CommonSearchBox from '../common/search-box/CommonSearchBox';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';

const ThemeThree = ({ history, operator }) => {
	// const openWhatsapp = () => {
	// 	window.open(`//api.whatsapp.com/send?phone=${operator.phone_number}`, "_blank");
	// };
	const openWhatsapp = () => {
		const phoneNumber = operator.phone_number.replace(/\D/g, '');
		window.open(`//api.whatsapp.com/send?phone=${phoneNumber}`, "_blank");
	};


	const responsive = {
		superLargeDesktop: {
			// the naming can be any, depends on you.
			breakpoint: { max: 4000, min: 3000 },
			items: 4,
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: operator && operator.operator_name === "aeroquinta" || operator.operator_name === "basetorres" ? 4 : 5,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};
	return (
		<div className="theme-three">




			<div
				style={{
					position: 'relative',
					paddingTop: operator && operator.operator_name === 'busnorte' ? 90 : '',

				}}>


				{operator && operator.operator_name === 'busnorte' ?
					(
						<HomeBanners
							slides={getSlides('Banner', operator)}
							// height={'92vh'}

							activeDotColor={operator && operator.operator_name === 'busnorte' ? '#d9d528' : ""}
						// containerStyle={{ paddingTop: 90 }}
						/>
					) : operator && operator.operator_name === 'aeroquinta' ? (
						<HomeBanners
							slides={getSlides('Banner', operator)}
							activeDotColor='#4079BC'
							marginTop={90}
						// Additional props or styles here
						/>
					) : operator && operator.operator_name === 'arzola' ? (
						<HomeBanners
							slides={getSlides('Banner', operator)}
							activeDotColor='#93e61a'
							marginTop={90}

						/>
					) : operator && operator.operator_name === 'basetorres' ? (
						<HomeBanners
							slides={getSlides('Banner', operator)}
							activeDotColor='#4f7391'
							marginTop={90}

						/>

					) : (
						<HomeBanners
							slides={getSlides('Banner', operator)}
							activeDotColor={operator && operator.operator_name === 'busnorte' ? '#d9d528' : ' '}

						/>)
				}
				<div className="searchboxoverlay">

					<CommonSearchBox history={history} operator={operator} />
				</div>

				{operator && operator.operator_name === "basetorres" ?
					(
						// <div className="fixed-whtsapp">

						// 	<img src="/assets/ivergrama/home/whtsapp.svg" />
						// </div>
						<div
							style={{
								position: "relative",
								// bottom: "24px",
								// right: "24px",
								// zIndex: 1000,
								// display: "flex",
								// alignItems: "center",
								// justifyContent: "center",
								// cursor: "pointer",
							}}
							onClick={openWhatsapp}
							className='new-container'
						>
							<img
								src="/assets/torres/homepage/whtsapp.svg"
								style={{
									position: "absolute",
									bottom: "24px",
									right: "0px",
									zIndex: 1000,

									cursor: "pointer",
									width: "auto",
								}}
								height={50}
								width={50}
							/>
						</div>
					) : (null)
				}
			</div>

			<div className="service-banner new-container">
				<img src={getIcons('servicesBanner', operator)} alt=""
					style={{

						marginLeft: operator && operator.operator_name === 'busnorte' || operator && operator.operator_name === 'aeroquinta' || operator && operator.operator_name === 'arzola' || operator && operator.operator_name === 'basetorres' ? 0 : -35,
					}}
				/>
			</div>
			{(operator && operator.operator_name === 'aeroquinta') ? <ThemeThreeTitle operator={operator} title="Conoce nuestra ruta" /> : <ThemeThreeTitle operator={operator} title="Nuestros destinos favoritos" />}

			<div className="new-container">
				<div className="service-banners">


					{operator && operator.operator_name === "aeroquinta" ?
						(
							<div>
								<ul className="d-flex justify-center">
									<li className='px-2'><img src="/assets/aeroquinta/Home/service1.png" style={{}} /></li>
									<li className='px-3'><img src="/assets/aeroquinta/Home/service4.png" style={{}} /></li>
								</ul>
							</div>

						) : operator && operator.operator_name === "basetorres" ?
							(

								<div className='torresslider'>
									<Carousel
										responsive={responsive}
										swipeable={false}
										draggable={false}
										showDots={operator && operator.operator_name === 'basetorres' ? "true" : "false"}
										infinite={true}
										autoPlay={true}
										autoPlaySpeed={3000}
										customTransition="all .5"
										transitionDuration={3000}
										removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}

									>
										{getSlides('Services', operator) &&
											(getSlides('Services', operator).length || []) > 0 &&
											getSlides('Services', operator).map((slide, index) => {
												return (
													<div className="d" style={{ margin: '0px 20px' }} key={slide}>
														<img src={slide} alt="" className="" />
													</div>
												);
											})}
									</Carousel>
								</div>
							) :

							(

								<Carousel
									responsive={responsive}
									swipeable={false}
									draggable={false}
									showDots={operator && operator.operator_name === 'basetorres' ? "true" : "false"}
									infinite={true}
									autoPlay={true}
									autoPlaySpeed={3000}
									customTransition="all .5"
									transitionDuration={3000}
									removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}

								>
									{getSlides('Services', operator) &&
										(getSlides('Services', operator).length || []) > 0 &&
										getSlides('Services', operator).map((slide, index) => {
											return (
												<div className="d" style={{ margin: '0px 10px' }} key={slide}>
													<img src={slide} alt="" className="" />
												</div>
											);
										})}
								</Carousel>

							)

					}
				</div>
			</div>

			{
				(operator && operator.operator_name === 'ivergrama') ? (
					< ThemeThreeTitle operator={operator} title="¿Por qué elegir Ivergrama?" className="mt-5" />
				) : (operator && operator.operator_name === 'aeroquinta') ? (
					< ThemeThreeTitle operator={operator} title="¿Por qué elegir Aeroquinta?" className="mt-5" />
				) : (operator && operator.operator_name === 'busnorte') ? (
					<ThemeThreeTitle operator={operator} title="¿Por qué elegir Bus Norte?" className="mt-5" />
				) : (operator && operator.operator_name === 'basetorres') ? (
					<ThemeThreeTitle
						operator={operator}
						title={<span>¿Por qué elegir <strong>Base Torres</strong>?</span>}
						className="mt-5"
					/>

				) : ("")
			}

			<ThemeThreeIconsSection />

			<ThemeThreeContactForm homeImage homeForm />

		</div >
	);
};

const styles = {
	priceDetails: {
		position: 'absolute',
		bottom: '5px',
		color: 'white',
		width: '95%',
		textAlign: 'center',
	},
	label: {
		fontSize: '12px',
	},
	amount: {
		fontWeight: 'bold',
		marginTop: '4px',
	},
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeThree);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/ThemeThree.js